
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("l7rln", function(module, exports) {

$parcel$export(module.exports, "featureFlagsPlugin", () => $8eb28bf449dbd43f$export$79626a094e303f80);

var $1S4f7 = parcelRequire("1S4f7");

var $7T7aA = parcelRequire("7T7aA");
const $8eb28bf449dbd43f$var$pluginKey = new (0, $7T7aA.PluginKey)('featureFlags');
const $8eb28bf449dbd43f$export$79626a094e303f80 = ({ config: featureFlags = {} })=>({
        name: 'featureFlags',
        getSharedState (editorState) {
            if (!editorState) return featureFlags || {};
            return $8eb28bf449dbd43f$var$pluginKey.getState(editorState) || featureFlags || {};
        },
        pmPlugins () {
            return [
                {
                    name: 'featureFlags',
                    plugin: ()=>new (0, $1S4f7.SafePlugin)({
                            key: $8eb28bf449dbd43f$var$pluginKey,
                            state: {
                                init: ()=>({
                                        ...featureFlags
                                    }),
                                apply: (_, pluginState)=>pluginState
                            }
                        })
                }
            ];
        }
    });

});

parcelRegister("kbe7k", function(module, exports) {

$parcel$export(module.exports, "contextIdentifierPlugin", () => $62c1068719723e82$export$43b392516e89a467);

var $apksR = parcelRequire("apksR");
const $62c1068719723e82$export$43b392516e89a467 = ({ config: config, api: api })=>{
    return {
        name: 'contextIdentifier',
        commands: {
            setProvider: (config)=>({ tr: tr })=>{
                    // If no change, don't dispatch
                    if (config?.contextIdentifierProvider === api?.contextIdentifier?.sharedState.currentState()?.contextIdentifierProvider) return null;
                    return tr.setMeta((0, $apksR.pluginKey), {
                        contextIdentifierProvider: config?.contextIdentifierProvider
                    });
                }
        },
        getSharedState (state) {
            if (!state) return undefined;
            return {
                contextIdentifierProvider: (0, $apksR.pluginKey).getState(state)?.contextIdentifierProvider
            };
        },
        pmPlugins: ()=>{
            return [
                {
                    name: 'contextIdentifier',
                    plugin: (0, $apksR.createPlugin)(config, api)
                }
            ];
        }
    };
};

});
parcelRegister("apksR", function(module, exports) {

$parcel$export(module.exports, "pluginKey", () => $1bf41817841eac5e$export$18d4026d1ea86bb1);
$parcel$export(module.exports, "createPlugin", () => $1bf41817841eac5e$export$ae829ec7b2625219);

var $1S4f7 = parcelRequire("1S4f7");

var $7T7aA = parcelRequire("7T7aA");
const $1bf41817841eac5e$export$18d4026d1ea86bb1 = new (0, $7T7aA.PluginKey)('contextIdentiferPlugin');
async function $1bf41817841eac5e$var$updateContextIdentifier(config, api) {
    const provider = await config.contextIdentifierProvider;
    api?.core?.actions.execute(api?.contextIdentifier?.commands.setProvider({
        contextIdentifierProvider: provider
    }));
}
const $1bf41817841eac5e$export$ae829ec7b2625219 = (initialConfig, api)=>()=>{
        if (initialConfig) $1bf41817841eac5e$var$updateContextIdentifier(initialConfig, api);
        return new (0, $1S4f7.SafePlugin)({
            key: $1bf41817841eac5e$export$18d4026d1ea86bb1,
            state: {
                init: ()=>initialConfig,
                apply: (tr, pluginState)=>{
                    const meta = tr.getMeta($1bf41817841eac5e$export$18d4026d1ea86bb1);
                    return meta ? meta : pluginState;
                }
            }
        });
    };

});


parcelRegister("7nKrc", function(module, exports) {

$parcel$export(module.exports, "selectionToolbarPlugin", () => $9f031664f93dee36$export$b621d761b94834de);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $d8F95 = parcelRequire("d8F95");

var $d925B = parcelRequire("d925B");

var $1S4f7 = parcelRequire("1S4f7");

var $lNDSG = parcelRequire("lNDSG");

var $7T7aA = parcelRequire("7T7aA");

var $dh538 = parcelRequire("dh538");

var $iu6m9 = parcelRequire("iu6m9");

var $2gH2F = parcelRequire("2gH2F");

var $al42B = parcelRequire("al42B");

var $dArLd = parcelRequire("dArLd");

var $gTFHy = parcelRequire("gTFHy");

var $eQfrk = parcelRequire("eQfrk");
const $9f031664f93dee36$var$getToolbarDocking = (contextualFormattingEnabled, userPreferencesProvider)=>{
    if (contextualFormattingEnabled && (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1')) return userPreferencesProvider?.getPreference('toolbarDockingInitialPosition') ?? 'none';
    return 'top';
};
const $9f031664f93dee36$export$b621d761b94834de = ({ api: api, config: config })=>{
    const __selectionToolbarHandlers = [];
    let primaryToolbarComponent;
    const { userPreferencesProvider: userPreferencesProvider, contextualFormattingEnabled: contextualFormattingEnabled } = config;
    if ((0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1', {
        exposure: true
    })) {
        primaryToolbarComponent = ({ popupsBoundariesElement: popupsBoundariesElement, popupsMountPoint: popupsMountPoint, popupsScrollableElement: popupsScrollableElement })=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $eQfrk.PrimaryToolbarComponent), {
                api: api,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsMountPoint: popupsMountPoint,
                popupsScrollableElement: popupsScrollableElement
            });
        api?.primaryToolbar?.actions.registerComponent({
            name: 'overflowMenu',
            component: primaryToolbarComponent
        });
    }
    let previousToolbarDocking = userPreferencesProvider?.getPreference('toolbarDockingInitialPosition') || null;
    let isPreferenceInitialized = false;
    return {
        name: 'selectionToolbar',
        actions: {
            suppressToolbar: ()=>{
                return api?.core.actions.execute((0, $2gH2F.toggleToolbar)({
                    hide: true
                })) ?? false;
            },
            unsuppressToolbar: ()=>{
                return api?.core.actions.execute((0, $2gH2F.toggleToolbar)({
                    hide: false
                })) ?? false;
            },
            setToolbarDocking: (toolbarDocking)=>{
                return api?.core.actions.execute((0, $2gH2F.setToolbarDocking)({
                    toolbarDocking: toolbarDocking,
                    userPreferencesProvider: userPreferencesProvider,
                    editorAnalyticsApi: api?.analytics?.actions
                })) ?? false;
            },
            forceToolbarDockingWithoutAnalytics: (toolbarDocking)=>{
                return api?.core.actions.execute((0, $2gH2F.forceToolbarDockingWithoutAnalytics)({
                    toolbarDocking: toolbarDocking,
                    userPreferencesProvider: userPreferencesProvider
                })) ?? false;
            },
            refreshToolbarDocking: ()=>{
                if (userPreferencesProvider) {
                    const userToolbarDockingPref = $9f031664f93dee36$var$getToolbarDocking(contextualFormattingEnabled, userPreferencesProvider);
                    return api?.core.actions.execute((0, $2gH2F.updateToolbarDocking)({
                        toolbarDocking: userToolbarDockingPref
                    })) ?? false;
                }
                return false;
            }
        },
        getSharedState (editorState) {
            if (!editorState) return;
            return (0, $al42B.selectionToolbarPluginKey).getState(editorState);
        },
        pmPlugins (selectionToolbarHandlers) {
            if (selectionToolbarHandlers) __selectionToolbarHandlers.push(...selectionToolbarHandlers);
            return [
                {
                    name: 'selection-tracker',
                    plugin: ()=>{
                        return new (0, $1S4f7.SafePlugin)({
                            key: (0, $al42B.selectionToolbarPluginKey),
                            state: {
                                init () {
                                    return {
                                        selectionStable: false,
                                        hide: false,
                                        toolbarDocking: $9f031664f93dee36$var$getToolbarDocking(contextualFormattingEnabled, userPreferencesProvider)
                                    };
                                },
                                apply (tr, pluginState) {
                                    const meta = tr.getMeta((0, $al42B.selectionToolbarPluginKey));
                                    if (meta) return {
                                        ...pluginState,
                                        ...meta
                                    };
                                    // if the toolbarDockingInitialPosition preference has changed
                                    // update the toolbarDocking state
                                    if (!previousToolbarDocking && (0, $dh538.fg)('platform_editor_controls_patch_4')) {
                                        // we currently only check for the initial value
                                        const toolbarDockingPreference = userPreferencesProvider?.getPreference('toolbarDockingInitialPosition');
                                        if (toolbarDockingPreference && toolbarDockingPreference !== previousToolbarDocking) {
                                            previousToolbarDocking = toolbarDockingPreference;
                                            const userToolbarDockingPref = $9f031664f93dee36$var$getToolbarDocking(contextualFormattingEnabled, userPreferencesProvider);
                                            if (pluginState.toolbarDocking !== userToolbarDockingPref) return {
                                                ...pluginState,
                                                toolbarDocking: userToolbarDockingPref
                                            };
                                        }
                                    }
                                    return pluginState;
                                }
                            },
                            view (view) {
                                const unbind = (0, $d8F95.bind)(view.root, {
                                    type: 'mouseup',
                                    listener: ()=>{
                                        // We only want to set selectionStable to true if the editor has focus
                                        // to prevent the toolbar from showing when the editor is blurred
                                        // due to a click outside the editor.
                                        const editorViewModePlugin = api?.editorViewMode?.sharedState.currentState();
                                        const isViewModeEnabled = editorViewModePlugin?.mode === 'view';
                                        view.dispatch(view.state.tr.setMeta((0, $al42B.selectionToolbarPluginKey), {
                                            selectionStable: !isViewModeEnabled ? view.hasFocus() : true
                                        }));
                                    }
                                });
                                const unbindEditorViewFocus = (0, $d8F95.bind)(view.dom, {
                                    type: 'focus',
                                    listener: ()=>{
                                        view.dispatch(view.state.tr.setMeta((0, $al42B.selectionToolbarPluginKey), {
                                            selectionStable: true
                                        }));
                                    }
                                });
                                return {
                                    destroy () {
                                        unbind();
                                        unbindEditorViewFocus();
                                    }
                                };
                            },
                            appendTransaction (_transactions, _oldState, newState) {
                                if (!isPreferenceInitialized && (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') && (0, $dh538.fg)('platform_editor_controls_patch_2')) {
                                    const toolbarDockingPreference = userPreferencesProvider?.getPreference('toolbarDockingInitialPosition');
                                    if (toolbarDockingPreference !== undefined) {
                                        isPreferenceInitialized = true;
                                        const userToolbarDockingPref = $9f031664f93dee36$var$getToolbarDocking(contextualFormattingEnabled, userPreferencesProvider);
                                        const tr = newState.tr;
                                        if (!(0, $dh538.fg)('platform_editor_controls_patch_4')) tr.setMeta((0, $al42B.selectionToolbarPluginKey), {
                                            toolbarDocking: userToolbarDockingPref
                                        });
                                        api?.analytics?.actions.attachAnalyticsEvent({
                                            action: (0, $d925B.ACTION).INITIALISED,
                                            actionSubject: (0, $d925B.ACTION_SUBJECT).USER_PREFERENCES,
                                            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).SELECTION_TOOLBAR_PREFERENCES,
                                            attributes: {
                                                toolbarDocking: userToolbarDockingPref
                                            },
                                            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
                                        })(tr);
                                        return tr;
                                    }
                                }
                                return null;
                            },
                            props: {
                                handleDOMEvents: {
                                    mousedown: (view)=>{
                                        view.dispatch(view.state.tr.setMeta((0, $al42B.selectionToolbarPluginKey), {
                                            selectionStable: false
                                        }));
                                        return false;
                                    }
                                }
                            }
                        });
                    }
                }
            ];
        },
        pluginsOptions: {
            floatingToolbar (state, intl, providerFactory) {
                const { selectionStable: selectionStable, hide: hide, toolbarDocking: toolbarDocking } = (0, $al42B.selectionToolbarPluginKey).getState(state);
                const isCellSelection = '$anchorCell' in state.selection;
                const isEditorControlsEnabled = (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1');
                if (state.selection.empty || !selectionStable || hide || state.selection instanceof (0, $7T7aA.NodeSelection) || // $anchorCell is only available in CellSelection, this check is to
                // avoid importing CellSelection from @atlaskit/editor-tables
                isCellSelection && !isEditorControlsEnabled // for Editor Controls we want to show the toolbar on CellSelection
                ) // If there is no active selection, or the selection is not stable, or the selection is a node selection,
                // do not show the toolbar.
                return;
                if (isCellSelection && isEditorControlsEnabled && (0, $dh538.fg)('platform_editor_controls_patch_5')) {
                    const isSelectedViaDragHandle = api?.blockControls?.sharedState.currentState()?.isSelectedViaDragHandle;
                    if (isSelectedViaDragHandle) return;
                }
                // Resolve the selectionToolbarHandlers to a list of SelectionToolbarGroups
                // and filter out any handlers which returned undefined
                const resolved = __selectionToolbarHandlers.map((selectionToolbarHandler)=>selectionToolbarHandler(state, intl, providerFactory)).filter((resolved)=>resolved !== undefined);
                // Sort the groups by rank
                // This is intended to allow different plugins to control the order of the groups
                // they add to the selection toolbar.
                // ie. if you want to have your plugin's group appear first, set rank to -10 if there is currently another
                // plugin you expect to be run at the same time as with an rank of -9
                resolved.sort(({ rank: rankA = 0 }, { rank: rankB = 0 })=>{
                    if (rankA < rankB) return 1;
                    return -1;
                });
                const items = [];
                // This flattens the groups passed into the floating toolbar into a single list of items
                for(let i = 0; i < resolved.length; i++){
                    // add a seperator icon after each group except the last
                    if (Array.isArray(resolved[i]?.items)) items.push(...resolved[i].items);
                    if ((0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1')) {
                        if (resolved[i] && resolved[i + 1]) {
                            const shouldNotAddSeparator = resolved[i]?.pluginName === 'textColor' && resolved[i + 1]?.pluginName === 'highlight' || resolved[i]?.pluginName === 'alignment' && resolved[i + 1]?.pluginName === 'toolbarListsIndentation';
                            if (resolved[i + 1]?.pluginName === 'annotation') items.push({
                                type: 'separator',
                                fullHeight: true
                            });
                            else if (!(0, $dh538.fg)('platform_editor_controls_patch_6')) {
                                if (i !== resolved.length - 1 && !shouldNotAddSeparator) items.push({
                                    type: 'separator',
                                    fullHeight: false
                                });
                            }
                        }
                    } else if (i !== resolved.length - 1) items.push({
                        type: 'separator'
                    });
                }
                if (items.length > 0 && contextualFormattingEnabled && isEditorControlsEnabled) items.push(...(0, $dArLd.getOverflowFloatingToolbarConfig)({
                    api: api,
                    toolbarDocking: toolbarDocking,
                    intl: intl
                }));
                let onPositionCalculated;
                const toolbarTitle = 'Selection toolbar';
                if (isCellSelection && isEditorControlsEnabled) onPositionCalculated = (0, $lNDSG.calculateToolbarPositionOnCellSelection)(toolbarTitle);
                else {
                    const calcToolbarPosition = config.preferenceToolbarAboveSelection ? (0, $lNDSG.calculateToolbarPositionAboveSelection) : (0, $lNDSG.calculateToolbarPositionTrackHead);
                    onPositionCalculated = calcToolbarPosition(toolbarTitle);
                }
                const nodeType = $9f031664f93dee36$var$getSelectionNodeTypes(state);
                return {
                    title: 'Selection toolbar',
                    nodeType: nodeType,
                    items: items,
                    ...isEditorControlsEnabled && {
                        scrollable: true
                    },
                    onPositionCalculated: onPositionCalculated
                };
            }
        },
        contentComponent: (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') && (0, $dh538.fg)('platform_editor_user_preferences_provider_update') ? ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $gTFHy.PageVisibilityWatcher), {
                api: api,
                userPreferencesProvider: userPreferencesProvider
            }) : undefined,
        primaryToolbarComponent: !api?.primaryToolbar && (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1', {
            exposure: true
        }) ? primaryToolbarComponent : undefined
    };
};
function $9f031664f93dee36$var$getSelectionNodeTypes(state) {
    const selectionNodeTypes = [];
    state.doc.nodesBetween(state.selection.from, state.selection.to, (node, _pos, parent)=>{
        if (selectionNodeTypes.indexOf(node.type) !== 0) selectionNodeTypes.push(node.type);
    });
    return selectionNodeTypes;
}

});
parcelRegister("2gH2F", function(module, exports) {

$parcel$export(module.exports, "toggleToolbar", () => $35ef7d1ba42c2fa2$export$9bf0179b815bb489);
$parcel$export(module.exports, "updateToolbarDocking", () => $35ef7d1ba42c2fa2$export$78c8c4f9cf91105f);
$parcel$export(module.exports, "setToolbarDocking", () => $35ef7d1ba42c2fa2$export$c90257e445702eb2);
$parcel$export(module.exports, "forceToolbarDockingWithoutAnalytics", () => $35ef7d1ba42c2fa2$export$93bfa5da95924fe8);

var $d925B = parcelRequire("d925B");

var $7T7aA = parcelRequire("7T7aA");

var $dh538 = parcelRequire("dh538");

var $al42B = parcelRequire("al42B");
const $35ef7d1ba42c2fa2$export$9bf0179b815bb489 = ({ hide: hide })=>({ tr: tr })=>{
        tr.setMeta((0, $al42B.selectionToolbarPluginKey), {
            hide: hide
        });
        return tr;
    };
const $35ef7d1ba42c2fa2$export$78c8c4f9cf91105f = ({ toolbarDocking: toolbarDocking })=>({ tr: tr })=>{
        tr.setMeta((0, $al42B.selectionToolbarPluginKey), {
            toolbarDocking: toolbarDocking
        });
        return tr;
    };
const $35ef7d1ba42c2fa2$export$c90257e445702eb2 = ({ toolbarDocking: toolbarDocking, userPreferencesProvider: userPreferencesProvider, editorAnalyticsApi: editorAnalyticsApi })=>({ tr: tr })=>{
        // We currently ignore any update failures, need to confirm this is the desired behaviour
        userPreferencesProvider?.updatePreference('toolbarDockingInitialPosition', toolbarDocking);
        tr.setMeta((0, $al42B.selectionToolbarPluginKey), {
            toolbarDocking: toolbarDocking
        });
        if (toolbarDocking === 'top') // Remove the selection if the toolbar is docked to the top
        tr.setSelection((0, $7T7aA.TextSelection).create(tr.doc, tr.selection.head));
        if ((0, $dh538.fg)('platform_editor_controls_patch_2')) editorAnalyticsApi?.attachAnalyticsEvent({
            action: (0, $d925B.ACTION).UPDATED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).USER_PREFERENCES,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).SELECTION_TOOLBAR_PREFERENCES,
            attributes: {
                toolbarDocking: toolbarDocking
            },
            eventType: (0, $d925B.EVENT_TYPE).TRACK
        })(tr);
        return tr;
    };
const $35ef7d1ba42c2fa2$export$93bfa5da95924fe8 = ({ toolbarDocking: toolbarDocking, userPreferencesProvider: userPreferencesProvider })=>({ tr: tr })=>{
        userPreferencesProvider?.updatePreference('toolbarDockingInitialPosition', toolbarDocking);
        tr.setMeta((0, $al42B.selectionToolbarPluginKey), {
            toolbarDocking: toolbarDocking
        });
        return tr;
    };

});
parcelRegister("al42B", function(module, exports) {

$parcel$export(module.exports, "selectionToolbarPluginKey", () => $a54f7f7e66db851d$export$b382528b8197b4f1);

var $7T7aA = parcelRequire("7T7aA");
const $a54f7f7e66db851d$export$b382528b8197b4f1 = new (0, $7T7aA.PluginKey)('selectionToolbarPluginKey');

});


parcelRegister("dArLd", function(module, exports) {

$parcel$export(module.exports, "getOverflowFloatingToolbarConfig", () => $96a6ba033b702f63$export$547d4856c8150a9d);
$parcel$export(module.exports, "getOverflowPrimaryToolbarConfig", () => $96a6ba033b702f63$export$4c3311b0c1b6b110);
/* overflow-toolbar-config.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $5dODy = parcelRequire("5dODy");

var $iSCwd = parcelRequire("iSCwd");

var $5Yp2m = parcelRequire("5Yp2m");

var $aVJSQ = parcelRequire("aVJSQ");

var $gBbsI = parcelRequire("gBbsI");

var $dh538 = parcelRequire("dh538");
const $96a6ba033b702f63$export$547d4856c8150a9d = ({ api: api, toolbarDocking: toolbarDocking, intl: intl })=>{
    const isDockedToTop = toolbarDocking === 'top';
    const dropdownOptions = [
        {
            type: 'overflow-dropdown-heading',
            title: intl.formatMessage((0, $5dODy.selectionToolbarMessages).toolbarAppears)
        },
        {
            title: intl.formatMessage((0, $5dODy.selectionToolbarMessages).toolbarPositionInline),
            onClick: ()=>{
                return api?.selectionToolbar.actions?.setToolbarDocking?.('none') ?? false;
            },
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($5Yp2m)))({
                label: ''
            }),
            selected: !isDockedToTop,
            elemAfter: !isDockedToTop ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aVJSQ))), {
                label: ""
            }) : undefined
        },
        {
            title: intl.formatMessage((0, $5dODy.selectionToolbarMessages).toolbarPositionFixedAtTop),
            onClick: ()=>{
                return api?.selectionToolbar.actions?.setToolbarDocking?.('top') ?? false;
            },
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($iSCwd)))({
                label: ''
            }),
            selected: isDockedToTop,
            elemAfter: isDockedToTop ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aVJSQ))), {
                label: ""
            }) : undefined
        }
    ];
    // testId is required to show focus on trigger button on ESC key press
    // see hideOnEsc in platform/packages/editor/editor-plugin-floating-toolbar/src/ui/Dropdown.tsx
    const testId = (0, $dh538.fg)('platform_editor_controls_patch_8') ? 'selectionToolbar-overflow-dropdown-trigger' : undefined;
    return [
        {
            type: 'separator',
            fullHeight: true
        },
        {
            type: 'overflow-dropdown',
            testId: testId,
            dropdownWidth: 240,
            options: dropdownOptions
        }
    ];
};
const $96a6ba033b702f63$export$4c3311b0c1b6b110 = ({ api: api, intl: intl })=>[
        {
            items: [
                {
                    content: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gBbsI.default), {
                        children: intl.formatMessage((0, $5dODy.selectionToolbarMessages).toolbarAppears)
                    }),
                    value: {
                        name: ''
                    },
                    isDisabled: true
                },
                {
                    content: intl.formatMessage((0, $5dODy.selectionToolbarMessages).toolbarPositionInline),
                    value: {
                        name: 'contextual'
                    },
                    onClick: ()=>{
                        return api?.selectionToolbar.actions?.setToolbarDocking?.('none') ?? false;
                    },
                    elemBefore: (0, (/*@__PURE__*/$parcel$interopDefault($5Yp2m)))({
                        label: ''
                    })
                },
                {
                    content: intl.formatMessage((0, $5dODy.selectionToolbarMessages).toolbarPositionFixedAtTop),
                    value: {
                        name: 'fixed'
                    },
                    onClick: ()=>{
                        return api?.selectionToolbar.actions?.setToolbarDocking?.('top') ?? false;
                    },
                    isActive: true,
                    elemBefore: (0, (/*@__PURE__*/$parcel$interopDefault($iSCwd)))({
                        label: ''
                    }),
                    elemAfter: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aVJSQ))), {
                        label: ""
                    })
                }
            ]
        }
    ];

});
parcelRegister("iSCwd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4ecfaa2a7affab0b723faa26877e5072>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dbeb2621c43b09f2$var$_react = $dbeb2621c43b09f2$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $dbeb2621c43b09f2$var$_baseNew = $dbeb2621c43b09f2$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $dbeb2621c43b09f2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "DockToolbarTop".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for docking a toolbar to the top of a page
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $dbeb2621c43b09f2$var$DockToolbarTopIcon = (props)=>/*#__PURE__*/ $dbeb2621c43b09f2$var$_react.default.createElement($dbeb2621c43b09f2$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zm9 3H4V4h8z" clip-rule="evenodd"/>`
    }, props));
$dbeb2621c43b09f2$var$DockToolbarTopIcon.displayName = 'DockToolbarTopIcon';
var $dbeb2621c43b09f2$var$_default = module.exports.default = $dbeb2621c43b09f2$var$DockToolbarTopIcon;

});


parcelRegister("gTFHy", function(module, exports) {

$parcel$export(module.exports, "PageVisibilityWatcher", () => $3f59dbd744c5a7fd$export$57bf1011afa72cdf);

var $gwFzn = parcelRequire("gwFzn");

var $d8F95 = parcelRequire("d8F95");

var $hWRJP = parcelRequire("hWRJP");

var $dh538 = parcelRequire("dh538");
const $3f59dbd744c5a7fd$export$57bf1011afa72cdf = ({ api: api, userPreferencesProvider: userPreferencesProvider })=>{
    (0, $gwFzn.useEffect)(()=>{
        if (!userPreferencesProvider || !api) return;
        if (!(0, $dh538.fg)('platform_editor_controls_patch_6')) return (0, $d8F95.bind)(document, {
            type: 'visibilitychange',
            listener: async ()=>{
                if (document.visibilityState === 'visible') {
                    try {
                        await userPreferencesProvider.loadPreferences();
                    } catch (error) {
                        (0, $hWRJP.logException)(error, {
                            location: 'editor-plugin-selection-toolbar/PageVisibilityWatcher'
                        });
                    }
                    api?.selectionToolbar?.actions?.refreshToolbarDocking?.();
                }
            }
        });
        const refreshPrefrerence = async ()=>{
            if (document.visibilityState === 'visible') {
                try {
                    await userPreferencesProvider.loadPreferences();
                } catch (error) {
                    (0, $hWRJP.logException)(error, {
                        location: 'editor-plugin-selection-toolbar/PageVisibilityWatcher'
                    });
                }
                api?.selectionToolbar?.actions?.refreshToolbarDocking?.();
            }
        };
        refreshPrefrerence();
        return (0, $d8F95.bind)(document, {
            type: 'visibilitychange',
            listener: refreshPrefrerence
        });
    }, [
        api,
        userPreferencesProvider
    ]);
    return null;
};

});

parcelRegister("eQfrk", function(module, exports) {

$parcel$export(module.exports, "PrimaryToolbarComponent", () => $321ab3976fd6480f$export$94516d5cccf573e3);
/* PrimaryToolbarComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $dBxQj = parcelRequire("dBxQj");

var $d925B = parcelRequire("d925B");

var $hgeg8 = parcelRequire("hgeg8");

var $61p3e = parcelRequire("61p3e");

var $5v8Ta = parcelRequire("5v8Ta");
var $h4TOP = parcelRequire("h4TOP");
var $a4eZN = parcelRequire("a4eZN");

var $9VJDA = parcelRequire("9VJDA");

var $dh538 = parcelRequire("dh538");

var $dArLd = parcelRequire("dArLd");
const $321ab3976fd6480f$var$DROPDOWN_WIDTH = 240;
const $321ab3976fd6480f$var$buttonStyles = null;
function $321ab3976fd6480f$export$94516d5cccf573e3({ api: api, popupsBoundariesElement: popupsBoundariesElement, popupsMountPoint: popupsMountPoint, popupsScrollableElement: popupsScrollableElement }) {
    const intl = (0, $dBxQj.default)();
    const [isOpen, setIsOpen] = (0, $gwFzn.useState)(false);
    const items = (0, $gwFzn.useMemo)(()=>(0, $dArLd.getOverflowPrimaryToolbarConfig)({
            api: api,
            intl: intl
        }), [
        api,
        intl
    ]);
    const content = intl.formatMessage((0, $61p3e.default).viewMore);
    const onClick = (0, $gwFzn.useCallback)(()=>{
        setIsOpen(!isOpen);
    }, [
        isOpen
    ]);
    const onMenuItemActivated = (0, $gwFzn.useCallback)(({ item: item })=>{
        item?.onClick?.();
    }, []);
    (0, $gwFzn.useEffect)(()=>{
        if ((0, $dh538.fg)('platform_editor_controls_patch_4')) api?.analytics?.actions.fireAnalyticsEvent({
            action: (0, $d925B.ACTION).RENDERED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).TOOLBAR,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).DOCKED_PRIMARY_TOOLBAR,
            eventType: (0, $d925B.EVENT_TYPE).UI
        });
         // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $h4TOP.default), {
        isOpen: isOpen,
        onOpenChange: (attrs)=>setIsOpen(attrs.isOpen),
        items: items,
        arrowKeyNavigationProviderOptions: {
            type: (0, $5v8Ta.ArrowKeyNavigationType).MENU
        },
        boundariesElement: popupsBoundariesElement,
        mountTo: popupsMountPoint,
        scrollableElement: popupsScrollableElement,
        section: {
            hasSeparator: true
        },
        onItemActivated: onMenuItemActivated,
        fitWidth: $321ab3976fd6480f$var$DROPDOWN_WIDTH,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $a4eZN.default), {
            onClick: onClick,
            "aria-haspopup": "dialog",
            "aria-keyshortcuts": (0, $hgeg8.getAriaKeyshortcuts)((0, $hgeg8.addLink)),
            "aria-label": content,
            title: content,
            className: (0, $35pXk.default)([
                "_ca0q12x7 _n3td12x7 _19bv12x7 _u5f312x7"
            ]),
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))), {
                label: content
            })
        })
    });
}

});


parcelRegister("itirX", function(module, exports) {

$parcel$export(module.exports, "primaryToolbarPlugin", () => $e505b2a6e9f3b5fd$export$ad7799fd22a76abd);

var $46rVE = parcelRequire("46rVE");

var $dqpsa = parcelRequire("dqpsa");

var $hqUzz = parcelRequire("hqUzz");
const $e505b2a6e9f3b5fd$export$ad7799fd22a76abd = ({ config: config })=>{
    // We use a plugin variable to store the component registry to avoid having to use
    // effects in each plugin, and to enable rendering the toolbar in SSR
    // TODO: ED-26962 - Replace this with something in plugin state once we have a way to initialise across plugins on plugin initialisation
    const componentRegistry = new Map();
    // Pre-fill registry with the separator component
    componentRegistry.set('separator', (0, $hqUzz.default));
    return {
        name: 'primaryToolbar',
        actions: {
            registerComponent: (0, $46rVE.registerComponent)(componentRegistry)
        },
        pmPlugins: ()=>[
                {
                    name: 'primaryToolbar',
                    plugin: ()=>(0, $dqpsa.createPlugin)({
                            componentRegistry: componentRegistry,
                            contextualFormattingEnabled: config?.contextualFormattingEnabled
                        })
                }
            ],
        getSharedState (editorState) {
            if (!editorState) return;
            return (0, $dqpsa.primaryToolbarPluginKey).getState(editorState);
        }
    };
};

});
parcelRegister("46rVE", function(module, exports) {

$parcel$export(module.exports, "registerComponent", () => $ce844b7854732342$export$d74092cddf07c0aa);
const $ce844b7854732342$export$d74092cddf07c0aa = (componentRegistry)=>({ name: name, component: component })=>{
        componentRegistry.set(name, component);
    };

});

parcelRegister("dqpsa", function(module, exports) {

$parcel$export(module.exports, "primaryToolbarPluginKey", () => $61a61062142b6645$export$36f60c8b3eb879ae);
$parcel$export(module.exports, "createPlugin", () => $61a61062142b6645$export$ae829ec7b2625219);

var $1S4f7 = parcelRequire("1S4f7");

var $7T7aA = parcelRequire("7T7aA");

var $5YgfN = parcelRequire("5YgfN");
const $61a61062142b6645$export$36f60c8b3eb879ae = new (0, $7T7aA.PluginKey)('primaryToolbar');
const $61a61062142b6645$export$ae829ec7b2625219 = ({ componentRegistry: componentRegistry, contextualFormattingEnabled: contextualFormattingEnabled })=>{
    return new (0, $1S4f7.SafePlugin)({
        key: $61a61062142b6645$export$36f60c8b3eb879ae,
        state: {
            init: (_config, editorState)=>({
                    components: (0, $5YgfN.getToolbarComponents)({
                        componentRegistry: componentRegistry,
                        editorState: editorState,
                        contextualFormattingEnabled: contextualFormattingEnabled
                    })
                }),
            apply: (_tr, pluginState)=>pluginState
        }
    });
};

});
parcelRegister("5YgfN", function(module, exports) {

$parcel$export(module.exports, "getToolbarComponents", () => $7aa852d107b41e9c$export$a758406ca53b86a5);

var $dh538 = parcelRequire("dh538");

var $iu6m9 = parcelRequire("iu6m9");
const $7aa852d107b41e9c$export$a758406ca53b86a5 = ({ componentRegistry: componentRegistry, editorState: editorState, contextualFormattingEnabled: contextualFormattingEnabled })=>{
    let configuration;
    if (contextualFormattingEnabled && (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1', {
        exposure: true
    })) {
        const shouldShowUndoRedoGroup = (0, $dh538.fg)('platform_editor_undo_redo_find_on_primary_toolbar');
        configuration = $7aa852d107b41e9c$var$toolbarConfigurationV2(true, shouldShowUndoRedoGroup);
    } else {
        const shouldShowFindGroup = !(!contextualFormattingEnabled && (0, $dh538.fg)('platform_editor_controls_fix_toolbar_config_embeds'));
        configuration = $7aa852d107b41e9c$var$toolbarConfiguration(shouldShowFindGroup);
    }
    return configuration.filter((toolbarElement)=>typeof toolbarElement.enabled === 'undefined' || toolbarElement.enabled(componentRegistry, editorState)).reduce((acc, toolbarElement)=>{
        if (componentRegistry.has(toolbarElement.name)) {
            const component = componentRegistry.get(toolbarElement.name);
            if (!!component) acc.push(component);
        }
        return acc;
    }, []);
};
const $7aa852d107b41e9c$var$undoRedoGroup = [
    {
        name: 'undoRedoPlugin'
    },
    {
        name: 'separator',
        enabled: (componentRegistry)=>componentRegistry.has('undoRedoPlugin')
    }
];
const $7aa852d107b41e9c$var$spellCheckGroup = [
    {
        name: 'spellCheck'
    },
    {
        name: 'separator',
        enabled: (componentRegistry)=>componentRegistry.has('spellCheck')
    }
];
const $7aa852d107b41e9c$var$blockTypeGroup = [
    {
        name: 'blockType'
    },
    {
        name: 'separator',
        enabled: (componentRegistry, editorState)=>componentRegistry.has('blockType') && // Use case where you want to have the block plugin but not render any toolbar items (when you exclude headings), we should be able to get rid of this when we split block type plugin up and check for the presence of the heading plugin directly
            !!editorState.schema.nodes.heading
    }
];
const $7aa852d107b41e9c$var$textFormattingGroup = [
    {
        name: 'textFormatting'
    },
    {
        name: 'separator',
        enabled: (componentRegistry)=>componentRegistry.has('textFormatting')
    }
];
const $7aa852d107b41e9c$var$alignmentGroup = [
    {
        name: 'alignment'
    },
    {
        name: 'separator',
        enabled: (componentRegistry)=>componentRegistry.has('alignment')
    }
];
const $7aa852d107b41e9c$var$textColorGroup = [
    {
        name: 'textColor'
    },
    {
        name: 'highlight'
    },
    {
        name: 'separator',
        enabled: (componentRegistry)=>componentRegistry.has('textColor') || componentRegistry.has('highlight')
    }
];
const $7aa852d107b41e9c$var$listFormattingGroup = [
    {
        name: 'toolbarListsIndentation'
    },
    {
        name: 'separator',
        enabled: (componentRegistry)=>componentRegistry.has('toolbarListsIndentation')
    }
];
const $7aa852d107b41e9c$var$hyperlinkGroup = [
    {
        name: 'hyperlink'
    },
    {
        name: 'separator',
        enabled: (componentRegistry)=>componentRegistry.has('hyperlink')
    }
];
const $7aa852d107b41e9c$var$insertBlockGroup = [
    {
        name: 'insertBlock'
    }
];
const $7aa852d107b41e9c$var$others = [
    {
        name: 'beforePrimaryToolbar'
    },
    {
        name: 'avatarGroup'
    },
    {
        name: 'findReplace'
    },
    {
        // TODO: ED-26962 - Should likely be split into three: spelling & grammar, separator, and AI trigger
        name: 'aiExperience'
    },
    {
        name: 'loom'
    }
];
const $7aa852d107b41e9c$var$othersGroupNoFind = [
    {
        name: 'beforePrimaryToolbar'
    },
    {
        name: 'avatarGroup'
    },
    {
        // TODO: ED-26962 - Should likely be split into three: spelling & grammar, separator, and AI trigger
        name: 'aiExperience'
    },
    {
        name: 'loom'
    }
];
const $7aa852d107b41e9c$var$findGroup = [
    {
        name: 'findReplace'
    }
];
const $7aa852d107b41e9c$var$toolbarConfiguration = (shouldShowFindGroup)=>[
        ...$7aa852d107b41e9c$var$undoRedoGroup,
        ...$7aa852d107b41e9c$var$spellCheckGroup,
        ...$7aa852d107b41e9c$var$blockTypeGroup,
        ...$7aa852d107b41e9c$var$textFormattingGroup,
        ...$7aa852d107b41e9c$var$alignmentGroup,
        ...$7aa852d107b41e9c$var$textColorGroup,
        ...$7aa852d107b41e9c$var$listFormattingGroup,
        ...$7aa852d107b41e9c$var$insertBlockGroup,
        ...shouldShowFindGroup ? $7aa852d107b41e9c$var$others : $7aa852d107b41e9c$var$othersGroupNoFind
    ];
const $7aa852d107b41e9c$var$toolbarConfigurationV2 = (shouldShowInsertBlock, shouldShowUndoRedoGroup, shouldShowFindGroup = false)=>[
        ...shouldShowUndoRedoGroup ? $7aa852d107b41e9c$var$undoRedoGroup : [],
        ...$7aa852d107b41e9c$var$blockTypeGroup,
        ...$7aa852d107b41e9c$var$textFormattingGroup,
        ...$7aa852d107b41e9c$var$textColorGroup,
        ...$7aa852d107b41e9c$var$alignmentGroup,
        ...$7aa852d107b41e9c$var$listFormattingGroup,
        ...$7aa852d107b41e9c$var$hyperlinkGroup,
        ...shouldShowInsertBlock ? $7aa852d107b41e9c$var$insertBlockGroup : [],
        {
            name: 'overflowMenu'
        },
        {
            name: 'beforePrimaryToolbar'
        },
        ...shouldShowFindGroup ? $7aa852d107b41e9c$var$findGroup : []
    ];

});


parcelRegister("hqUzz", function(module, exports) {

$parcel$export(module.exports, "default", () => $92f8db87568333ef$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3jLHL = parcelRequire("3jLHL");

var $cORDs = parcelRequire("cORDs");
var $92f8db87568333ef$export$2e2bcd8739ae039 = ()=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $3jLHL.jsx)("span", {
        css: (0, $cORDs.wrapperStyle)
    }, /*#__PURE__*/ (0, $3jLHL.jsx)("span", {
        "data-vc": "primary-toolbar-separator",
        css: (0, $cORDs.separatorStyles)
    }));

});



//# sourceMappingURL=FullPageEditorComponent.62d8211a.js.map
